export default {
  selectCustomFields: (state) => state.customFields.customFields,
};
